export const TOGGLE_LOADER = "TOGGLE_LOADER";
export const TOGGLE_INVITE = "TOGGLE_INVITE";
export const SHOW_NORTHWELL_ERROR = "SHOW_NORTHWELL_ERROR";
export const SET_EMAIL_LOGIN = "SET_EMAIL_LOGIN";
export const SET_SSO_TOKEN = "SET_SSO_TOKEN";
export const SET_IS_MARKETING = "SET_IS_MARKETING";
export const SET_PAYMENT_INTERVAL = "SET_PAYMENT_INTERVAL";
export const SET_REFERRAL_CODE = "SET_REFERRAL_CODE";

export const toggleLoader = () => {
   return {
      type: TOGGLE_LOADER,
   };
};

export const toggleInvite = (payload) => {
   return {
      type: TOGGLE_INVITE,
      payload,
   };
};

export const toggleNorthwellError = () => {
   return {
      type: SHOW_NORTHWELL_ERROR,
   };
};

export const setLoginEmail = (payload) => {
   return {
      type: SET_EMAIL_LOGIN,
      payload,
   };
};

export const setSsoLoginToken = (payload) => {
   return {
      type: SET_SSO_TOKEN,
      payload,
   };
};

export const isUserFromMarketing = () => {
   return {
      type: SET_IS_MARKETING,
   };
};

export const setPaymentStatus = () => {
   return {
      type: SET_PAYMENT_INTERVAL,
   };
};

export const setReferralCode = (payload) => {
   return {
      type: SET_REFERRAL_CODE,
      payload,
   };
};
